import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";
import { useDispatch } from "react-redux";
import {
  addChatModelMessageAsync,
  getChatModelEditsAndResponsesMessages,
  getModelChatMessage,
} from "../one-query/ChatModelSlice";
import { useAppDispatch, useAppSelector } from "../hooks";
import { setDefaultModelMode, setLimitAlert } from "../one-query/chatsSlice";
import { useState } from "react";
import { ChatModelState } from "../../Helper";

import { UserState } from "../account/userSlice";
import { HandleErrorForLimitations } from "../../HandleErrorForLimitationsHelper";
export interface TranslatePromptProps {
  prompt: string | undefined;
  connectionId: string;
  language: string;
}

// function to get messages from GPT
const getChatModelMessages = async (conversationId: string | undefined) => {
  try {
    const response = await Api.get(
      `Conversation/${conversationId}/GetAllMessages`
    );
    return response.data;
  } catch (e) {}
};

//custom hook to get messages from Chat model using useQuery
const useGetChatModelMessages = (conversationId:string) => {
  return useQuery({
    queryKey: ["ChatModelMessages",conversationId],
    queryFn:()=> getChatModelMessages(conversationId),
    enabled:!!conversationId
  });
};

/////////////////////////////////
interface RegenerateRequestData {
  messageId: string;
  connectionId: string;
  dispatch: any;
  user: UserState;
  isGenerateImage: boolean;
  isNeedWebSearch: boolean
  outputLanguage: string;
  newPrompt: null,
}
// Regenerate Message Endpoint
const regenerateMessage = async (data: RegenerateRequestData) => {
  const { user, dispatch } = data;
  const requestData = {
    messageId: data.messageId,
    connectionId: data.connectionId,
    isGenerateImage: data.isGenerateImage,
    isNeedWebSearch: data.isNeedWebSearch,
    outputLanguage: data.outputLanguage,
    newPrompt: data.newPrompt
  }
  try {
    const response = await Api.post("/Chat/RegenerateMessage",requestData);
    return response.data;
  } catch (e: any) {
      HandleErrorForLimitations({user,dispatch,errorMessage:e?.response?.data})
    throw e; // Re-throw so that useMutation can handle it in
};
}
// Custom hook to get new response
const useRegenerateMessages = () => {
  return useMutation({
    mutationKey: ["RegenerateMessage"],
    mutationFn: (data: RegenerateRequestData) => regenerateMessage(data),
  });
};


// Help & Support model endpoint
export const handleSendHelpRequest = (
  query: string,
  getConnectionId: string | null
) => {
  Api.post(`/HelpAndSupport?prompt=${query}&connectionId=${getConnectionId}`);
};

// ================================================================================

// Get default model mode

const getDefaultModelMode = async () => {
  const response = await Api.get("/DefaultModelModeSettings");
  return response.data;
};

const useGetDefaultModelMode = () => {
  return useQuery({
    queryKey: ["DefaultModelMode"],
    queryFn: getDefaultModelMode,
    staleTime: 1000 * 60 * 5,
  });
};

// ================================================================================
  // Improve prompt endpoint 
const improvePromptRequest = async (prompt: string | undefined,connectionId:string) => {
    const response = await Api.post("/Chat/EnhancePrompt",{prompt,connectionId});
    return response.data;
  };

  const useImprovePromptRequest = () => {
    return useMutation({
      mutationKey:["ImprovePrompt"],
      mutationFn: ({ prompt, connectionId }: { prompt: string | undefined; connectionId: string }) => improvePromptRequest(prompt, connectionId),
    });
  };

// ================================================================================
// Translate prompt endpoint

const translatePromptRequest = async (RequestData: TranslatePromptProps) => {
  const response = await Api.post("Chat/TranlsateMessage", RequestData);
  return response.data;
};

const useTranslatePromptRequest = () => {
  return useMutation({
    mutationKey: ["TranslatePrompt"],
    mutationFn: (RequestData: TranslatePromptProps) =>
      translatePromptRequest(RequestData),
  });
};

// get attachment link
const getAttachmentLink = async ({ messageId, url }: { messageId: string; url: string }) => {
  const response = await Api.get(
    `/ResponseAttach?messageId=${messageId}&&url=${url}`
  );
  return response.data;
};
const useGetAttachmentLink = () => {
  return useMutation({
    mutationKey: ["AttachmentLink"],
    mutationFn: getAttachmentLink,
  });
};
export {
  useGetChatModelMessages,
  useGetDefaultModelMode,
  useTranslatePromptRequest,
  useImprovePromptRequest,
  useGetAttachmentLink,
  useRegenerateMessages
};
